export default `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<g fill="currentColor">
	<path class="st0" d="M15.42,5.33V4.25c0-0.45-0.1-0.83-0.3-1.14c-0.17-0.26-0.4-0.46-0.69-0.59c-0.2-0.09-0.41-0.15-0.65-0.18
		c-0.1-0.01-0.17-0.01-0.24-0.01c-0.02,0-0.03,0-0.04,0l-3,0c-0.45,0-0.83,0.1-1.14,0.3C9.1,2.8,8.91,3.03,8.77,3.32
		c-0.09,0.2-0.15,0.41-0.18,0.65C8.58,4.06,8.58,4.13,8.58,4.18c0,0.03,0,0.05,0,0.06l0,1.08h-4.5v0.84h1.5v12.5c0,0,0,0,0,0.16
		c0,0.02,0,0.04,0,0.06c0.01,0.07,0.02,0.18,0.04,0.32c0.06,0.35,0.16,0.68,0.31,0.98c0.21,0.43,0.51,0.77,0.89,1.02
		c0.46,0.31,1.02,0.46,1.68,0.46h7.42c0,0,0,0,0.16,0c0.01,0,0.03,0,0.04,0c0.06,0,0.15-0.02,0.28-0.04
		c0.3-0.06,0.57-0.17,0.82-0.33c0.55-0.34,1.2-1.06,1.2-2.54V6.17h1.5V5.33H15.42z M9.43,4.06c0.01-0.1,0.04-0.24,0.1-0.38
		C9.6,3.53,9.7,3.42,9.82,3.34c0.17-0.11,0.4-0.17,0.68-0.17l3.06,0c0.02-0.01,0.07,0,0.13,0.01c0.1,0.01,0.24,0.04,0.38,0.1
		c0.14,0.07,0.26,0.17,0.34,0.29c0.11,0.17,0.17,0.4,0.17,0.68v1.08H9.42l0-1.14C9.42,4.16,9.42,4.12,9.43,4.06z M17.58,18.75
		c0,0.88-0.27,1.5-0.8,1.83c-0.21,0.13-0.41,0.19-0.55,0.22c-0.08,0.02-0.14,0.02-0.18,0.03l0,0l-0.05,0H8.5
		c-0.49,0-0.89-0.11-1.21-0.32c-0.25-0.17-0.45-0.4-0.6-0.7c-0.11-0.22-0.19-0.47-0.23-0.74c-0.02-0.1-0.03-0.19-0.03-0.24
		c0-0.03,0-0.05,0-0.06V6.17h11.16V18.75z"/>
	<rect x="9.58" y="8.75" class="st0" width="0.84" height="10"/>
	<rect x="13.58" y="8.75" class="st0" width="0.84" height="10"/>
</g>
</svg>`;
